"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrequentlyAskedQuestionMetadata = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
let FrequentlyAskedQuestionMetadata = class FrequentlyAskedQuestionMetadata {
    visibleToTravelAgentCategories;
};
exports.FrequentlyAskedQuestionMetadata = FrequentlyAskedQuestionMetadata;
__decorate([
    (0, type_graphql_1.Field)(() => [legacy_enums_1.TravelAgentCategory], { nullable: true }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.TravelAgentCategory, { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], FrequentlyAskedQuestionMetadata.prototype, "visibleToTravelAgentCategories", void 0);
exports.FrequentlyAskedQuestionMetadata = FrequentlyAskedQuestionMetadata = __decorate([
    (0, type_graphql_1.ObjectType)("FrequentlyAskedQuestionMetadata")
], FrequentlyAskedQuestionMetadata);
//# sourceMappingURL=FrequentlyAskedQuestionMetadata.js.map